import { render, staticRenderFns } from "./DocumentsMassEditModal.vue?vue&type=template&id=38e49360&scoped=true&"
import script from "./DocumentsMassEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsMassEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsMassEditModal.vue?vue&type=style&index=0&id=38e49360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e49360",
  null
  
)

export default component.exports